module.exports = __webpack_public_path__ + "static/netflix-397e85c470f6768ccb4f31f574ffc102.png";